import LogoImg from "@/../../public/images/pelorus-logo.svg";
import accesssystem from "@/../../public/images/Access-control-system.svg";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { FaRegEyeSlash } from "react-icons/fa6";
import { FaRegEye } from "react-icons/fa6";
import AuthFooterScreen from "../../../component/layout/authfooter";
import { useCustomNavigate } from "../../../hooks/useCustomNavigate";
import { useLocation } from "react-router-dom";
import { AppRoute } from "../../../router/routerConstants";
import { useState } from "react";
// import { useDispatch } from "react-redux";
// import { toast } from "react-toastify";
import * as yup from "yup";
// import { ThunkDispatch } from 'redux-thunk';
// import { AnyAction } from 'redux';

import { ValidationCons } from "../../../validation/validationConstant";
import { useFormik } from 'formik';
import { showError, showSuccess } from "../../../utils/Common";
import { resetPasswordApi } from "../../../service/apis/auth.api";


const ResetPasswordScreen = () => {
    const [NavigateTo] = useCustomNavigate();

    // type AppDispatch = ThunkDispatch<{}, {}, AnyAction>;
    // const dispatch: AppDispatch = useDispatch();
    const { state } = useLocation();
    const [, setLoading] = useState(false);

    const [isPasswordVisible,setIsPasswordVisible] = useState(false);
    const [isCnfPasswordVisible,setIsCnfPasswordVisible] = useState(false);




    // const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
   
    //     e.preventDefault();
        
    //     const params = {
    //         otp: state.otp,
    //         password: newPassword,
    //     };

    //     const states = {
    //         email: state.email,
    //         otp: state.otp,
    //         password: newPassword,
    //     };
    //     if (!newPassword || newPassword.trim() === "") {
    //         showError("Please enter password");
    //         return;
    //     }
    //     if (!cnfPassword || cnfPassword.trim() === "") {
    //         showError("Please enter confirm password");
    //         return;
    //     }
    //     if(newPassword.trim()!==cnfPassword.trim())
    //     {
    //         showError("Password and confirm password not matching");
    //         return;
    //     }

    //     let validate = Validate.dynamicValidationNew("RegisterProfileStep2", params);
    //     if (validate !== "") {
    //         showError(validate);
    //         return;
    //     }


    //     dispatch(
    //         UpdateResetPassword({
    //             action: ResetPasswordUpdate,
    //             definition: "RegisterProfileStep2",
    //             data: states,
    //         },true)

    //     ).then((r) => {            
    //         if (r?.message==='Password reset Successfull') {
    //             NavigateTo(AppRoute.LOGIN,false);
    //         }
    //         else
    //         {
    //             const errorMessages = r.error?.error?.details;               

    //             if (errorMessages && typeof errorMessages === "object") {
    //                 Object.entries(errorMessages).forEach(([key, value]) => {
    //                     if (typeof value === "object" && value !== null && "message" in value) {
    //                         showError((value as { message: string }).message);
    //                     } else if (typeof value === "string") {
    //                         showError(value); 
    //                     } else {
    //                         showError(`Error in ${key}: ${JSON.stringify(value)}`);
    //                     }
    //                 });
    //             }
    //             else
    //             {
    //                 showError(r?.message);
    //             }

    //         }
    //     });
    // }

    const resetPasswordFormik = useFormik({
        initialValues: {
        newPassword: state.newPassword || "",
          cnfPassword: state.cnfPassword || "",
        },
        validationSchema: yup.object({
            newPassword: yup
              .string()
              .trim()
              .min(8, ValidationCons.PASSWORD_CASE)
              .max(15, 'Password must not exceed 15 characters') 
              .required(ValidationCons.PASSWORD_REQUIRED)
              .matches(
                /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,15}$/,
                ValidationCons.PASSWORD_MATCH
              ),
              
            cnfPassword: yup
            .string()
            .trim()
            .min(8, ValidationCons.PASSWORD_CASE)
            .required(ValidationCons.PASSWORD_REQUIRED)
            .matches(/\w/, ValidationCons.PASSWORD_VALID)
            .oneOf([yup.ref("newPassword")],ValidationCons.PASSWORD_MISMATCH),
        }),
        onSubmit: async (values:any) => {
            setLoading(true);
            try {
              const bodyData = {
                email: state.email,
                otp: state.otp,
                password: values.newPassword
              };
              const response = await resetPasswordApi(bodyData);
              
              if (response?.message==='Password reset Successfull') {
                showSuccess('Password updated');                
                NavigateTo(AppRoute.LOGIN,false);
            }
            else
            {
                const errorMessages = response.error?.error?.details;               

                if (errorMessages && typeof errorMessages === "object") {
                    Object.entries(errorMessages).forEach(([key, value]) => {
                        if (typeof value === "object" && value !== null && "message" in value) {
                            showError((value as { message: string }).message);
                        } else if (typeof value === "string") {
                            showError(value); 
                        } else {
                            showError(`Error in ${key}: ${JSON.stringify(value)}`);
                        }
                    });
                }
                else
                {
                    // showError(response?.message);
                }

            }
            } catch (error) {
              setLoading(false);
              showError(error);

            }
        

        }
    });
    return (<>


        <header className="header common-padd-lt-rt common-padd-small pb-0">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        <div className="logo text-left"><a onClick={() => NavigateTo(AppRoute.SPLASH)}><img src={LogoImg} alt="logo"/></a></div>
                    </div>
                </div>
            </div>
        </header>

        <div className="main-authModule">
            <section className="welcomebodylogin common-padd pb-0">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 leftlargeImg"><img src={accesssystem} alt={`logo`}/></div>
                        <div className="col-lg-6">
                            <div className="welcome-holder">
                                <h1>Reset Password</h1>
                                <p>Please enter your new password and confirm password below.</p>
                                <div className="login-form-area add-password-form mt-5">
                                    <Form onSubmit={resetPasswordFormik.handleSubmit}>
                                        <Form.Group className="mb-3 position-relative" controlId="formBasicPassword">
                                            <Form.Label>New Password</Form.Label>
                                            <Form.Control type={`${isPasswordVisible ? 'text' : 'password'}`} placeholder="Enter your password"                                           
                                            name="newPassword"
                                            onChange={resetPasswordFormik.handleChange}
                                            onBlur={resetPasswordFormik.handleBlur} 
                                            value={resetPasswordFormik.values.newPassword}
                                            isInvalid={
                                                !!resetPasswordFormik.errors.newPassword && 
                                                Boolean(resetPasswordFormik.touched.newPassword)}
                                        />
                                            <div className={`eye-icon ${isPasswordVisible ? 'red' : ''}`}>
                                                {isPasswordVisible ? <FaRegEye onClick={()=>setIsPasswordVisible(false)}/> : <FaRegEyeSlash onClick={()=>setIsPasswordVisible(true)}/>}
                                            </div>
                                             <Form.Control.Feedback type="invalid">
                                                 {typeof resetPasswordFormik.errors.newPassword === "string" && resetPasswordFormik.errors.newPassword}
                                             </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group className="mb-3 position-relative" controlId="formConfirmPassword">
                                            <Form.Label>Confirm Password</Form.Label>
                                            <Form.Control type={`${isCnfPasswordVisible ? 'text' : 'password'}`} placeholder="Re-enter your password to confirm" name="cnfPassword"
                                            onChange={resetPasswordFormik.handleChange}
                                            onBlur={resetPasswordFormik.handleBlur} 
                                            value={resetPasswordFormik.values.cnfPassword}
                                            isInvalid={
                                                !!resetPasswordFormik.errors.cnfPassword && 
                                                Boolean(resetPasswordFormik.touched.cnfPassword)}/>
                                            <div className={`eye-icon ${isCnfPasswordVisible ? 'red' : ''}`}>
                                                {isCnfPasswordVisible ? <FaRegEye onClick={()=>setIsCnfPasswordVisible(false)}/> : <FaRegEyeSlash onClick={()=>setIsCnfPasswordVisible(true)}/>}
                                            </div>
                                             <Form.Control.Feedback type="invalid">
                                                 {typeof resetPasswordFormik.errors.cnfPassword === "string" && resetPasswordFormik.errors.cnfPassword}
                                             </Form.Control.Feedback>
                                        </Form.Group>
                                        <div className="btn-holder mt-5">
                                            <Button className="btn w-100 btn-primary" variant="primary" type="submit">Submit</Button>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <AuthFooterScreen/> 






    </>)
}
export default ResetPasswordScreen;